import { Company, Location, ContactPoint, Industry, PostBox, ManualVerificationStatus, OpeningHours, OpeningHoursDay } from "./Company";

export const defaultLocationValue:Location = {
    id: "",
	// address: "",
	streetName: "",
	houseNumber: "",
	houseLetter: "",
	postalCode: "",
	postalArea: "",
	// municipality: "",
	// municipalityCode: "",
	// county: "",
	// region: "",
	// country: "",
	latitude: null,
	longitude: null,
	// tradeArea: "",
	// tradeAreaId: "",
	// addressText: "",
	// addressExtension: "",
	// officialCitySector: "",
	// citySector: "",
}

export function defaultContactPointsValues():ContactPoint {
	return {
    isMain: false,
	smsDisabled: false,
	findability: true,
	deleted: false,
	updated: false,
	deletable: true,
	name: "",
	type: "",
	source: "",
	sourceName: "",
	reservations: "",
	id: "new_" + crypto.randomUUID(),
	label: "",
	value: "",
	originalValue: "",
	sequenceNumber: null
	}
}

export const defaultIndustryValues:Industry = {
    id: "",
	code: "",
	isMain: false,
	name: "",
	deleted: false
}

export const defaultPostBox:PostBox = {
    postalArea: "",
	postalCode: "",
	number: "",
	postOffice: "",
	country: null,
}

export const defaultOpeningHours : OpeningHours = {
	days : [],
	showOpeningHours: false
}


export const defaultCompanyValue:Company = {
    unitId: "",
	id: "",
	name: "",
	legalName: "",
	companyCode: "",
	location: defaultLocationValue,
	mainContactPointId: "",
	mainIndustryCode: "",
	contactPoints: [defaultContactPointsValues()],
	emails: [defaultContactPointsValues()],
	phoneNumbers: [defaultContactPointsValues()],
	urls: [defaultContactPointsValues()],
	socialMediaUrls:[defaultContactPointsValues()],
	deletable: false,
	isConsentGiven: false,
	industries: [defaultIndustryValues],
	postBox: defaultPostBox,
	localMainOffice: false,
	mainOffice: false,
	legalInformationRaw: "",
	searchterms: [],
	savable: false,
	isHybrid: false,
	isManualGroup: false,
	isMemberOfManualGroup: false,
	openingHoursText: "",
	hasCapabilityMainNumber: false,
	hasProducts: false,
	manualVerificationStatus: ManualVerificationStatus.None,
	openingHours: defaultOpeningHours
}